module.exports = __webpack_public_path__ + "static/media/search_design_iteration_1.f0cd3ee5.png";